
import { IQuizQuestionRes } from '../../models/assignments/quiz-question.model';
import { AssignmentRes, ITheoryQuestionRes } from '../../models/assignments/theory-assignment.model';
import { ITrainerBioRes } from '../../models/trainerbio.model';
import deleteService from '../deleteService';
import getService from '../getService';
import postService from '../postService';
import putService from '../putService';

const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://20.126.75.78/naptin/api/v1/';

const GETCOURSEASSIGNMENTOPICS = 'courses/'
const GETANASSIGNMENTOPIC ='question-headers/'
const CREATEASSIGNMENTOPIC = 'question-headers'
const EDITASSIGNMENTOPIC = 'question-headers/'
const DELETEEASSIGNMENTTOPIC = 'question-headers/'
const GETASSIGNMENTQUESTIONS = 'question-headers/'
const CREATEASSIGNMENTQUESTION = 'question-headers/'
const GETANASSIGNMENTQUESTION = 'questions/'
const EDITANASSIGNMENTQUESTION = 'questions/'
const DELETEANASSIGNMENTQUESTION = 'questions/'
const GETQUESTIONOPTION = 'questions/'
const CREATEQUESTIONOPTION ='question-options'
const UPDATEQUESTIONOPTION ='question-options/{uuid}'
const DEconstEQUESTIONOPTION ='question-options/{uuid}'
const ANSWERQUESTIONS = 'courses/'
const UPLOADRESULT ='courses/'

class TrainerAssignmentService {
  
  async getCourseAssignmentTopics(uuid: string, session_id:string,term_id: string) {
    const response = await getService.get(`${CONFIG_API_URL}${GETCOURSEASSIGNMENTOPICS}${uuid}/question-headers/${session_id}/${term_id}`)
    const res :AssignmentRes = response.data
    return res;
  }
  async getAnAssignmentTopic(uuid: string) {
    const response = await getService.get(`${CONFIG_API_URL}${GETANASSIGNMENTOPIC}${uuid}`);
    const res :any = response.data
    return res;
  }
  async createAssignmentTopic(data: any) {
    const response = await postService.post(`${CONFIG_API_URL}${CREATEASSIGNMENTOPIC}`, data)
    const res :any = response.data
    return res;
  }
  async createAssignmentQuiz(uuid: string,data: any) {
    const response = await postService.post(`${CONFIG_API_URL}${GETCOURSEASSIGNMENTOPICS}${uuid}/quiz-template`, data)
    const res :any = response.data
    return res;
  }
  async answerQuizQuestions(uuid: string | undefined,data: any) {
    const response = await postService.post(`${CONFIG_API_URL}${ANSWERQUESTIONS}${uuid}/quiz-answers`, data)
    const res :any = response.data
    return res;
  }
  async submitTheoryQuestion(uuid: string | undefined,data: any) {
    const response = await postService.post(`${CONFIG_API_URL}${ANSWERQUESTIONS}${uuid}/theory-answers`, data)
    const res :any = response.data
    return res;
  }
  async deleteAssignmentTopic(uuid: string) {
    const response = await deleteService.delete(`${CONFIG_API_URL}${DELETEEASSIGNMENTTOPIC}${uuid}`)
    const res :any = response.data
    return res;
  }
  async editAnAssignmentTopic(uuid: string, data:any) {
    const response = await putService.put(`${CONFIG_API_URL}${EDITASSIGNMENTOPIC}${uuid}`,data);
    const res :any = response.data
    return res;
  }
  async getAssignmentQuestions(uuid: string) {
    const response = await getService.get(`${CONFIG_API_URL}${GETASSIGNMENTQUESTIONS}${uuid}/questions`);
    const res :any = response.data
    return res;
  }
  async getAssessmentAnswers(uuid: string | undefined) {
    const response = await getService.get(`${CONFIG_API_URL}${GETASSIGNMENTQUESTIONS}${uuid}/questions-answers`);
    const res :any = response.data
    return res;
  }
  ///api/v1/question-headers/{uuid}/questions-answers
  async createAssignmentQuestion(data: any,uuid:string) {
    const response = await postService.post(`${CONFIG_API_URL}${CREATEASSIGNMENTQUESTION}${uuid}/questions`, data)
    const res :ITheoryQuestionRes = response.data 
    return res;
  }
  
  async markTheoryAnswers(data: any,uuid: any,question_header : any) {
    const response = await postService.post(`${CONFIG_API_URL}trainers/course/${uuid}/assessments/${question_header}/mark`, data)
    const res :any = response.data 
    return res;
  }
 
  async getAnAssignmentQuestion(uuid: string) {
    const response = await getService.get(`${CONFIG_API_URL}${GETANASSIGNMENTQUESTION}${uuid}`);
    const res :any = response.data
    return res;
  }
  async getAnsweredAssignmentQuestions(uuid: string) {
    const response = await getService.get(`${CONFIG_API_URL}question-headers/${uuid}/questions-answers`);
    const res :any = response.data
    return res;
  }
  async editAnAssignmentQuestion(uuid: string, data:any) {
    const response = await putService.put(`${CONFIG_API_URL}${EDITANASSIGNMENTQUESTION}${uuid}`,data);
    const res :any = response.data
    return res;
  }
  async deleteAssignmentQuestion(uuid: string) {
    const response = await deleteService.delete(`${CONFIG_API_URL}${DELETEANASSIGNMENTQUESTION}${uuid}`)
    const res :any = response.data
    return res;
  }
  async getQuestionOptions(uuid: string) {
    const response = await getService.get(`${CONFIG_API_URL}${GETQUESTIONOPTION}${uuid}/options`);
    const res :any = response.data
    return res;
  }
  async createQuestionOption(data: any) {
    const response = await postService.post(`${CONFIG_API_URL}${CREATEQUESTIONOPTION}`, data)
    const res :any = response.data 
    return res;
  }
  async editQuestionOption(uuid: string, data:any) {
    const response = await putService.put(`${CONFIG_API_URL}${UPDATEQUESTIONOPTION}${uuid}`,data);
    const res :any = response.data
    return res;
  }
  async deleteQuestionOption(uuid: string) {
    const response = await deleteService.delete(`${CONFIG_API_URL}${DEconstEQUESTIONOPTION}${uuid}`)
    const res :any = response.data
    return res;
  }
  // async uploadResult(uuid: string | undefined,data: any) {
  //   const response = await postService.post(`${CONFIG_API_URL}${UPLOADRESULT}${uuid}/results`, data)
  //   const res :any = response.data
  //   return res;
  // }
  
}

export default new TrainerAssignmentService();